import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Vision } from "../components/site/Vision";
import { FirstWorld } from "../components/site/FirstWorld";
import { Different } from "../components/site/Different";
import { VerticalSlice } from "../components/site/VerticalSlice";
import { Roadmap } from "../components/site/Roadmap";
import { Community } from "../components/site/Community";
import { Footer } from "../components/site/Footer";

export default function Home() {
    return (
        <div className="bg-[#050507] min-h-screen" data-testid="home-page">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Vision />
                <FirstWorld />
                <Different />
                <VerticalSlice />
                <Roadmap />
                <Community />
            </main>
            <Footer />
        </div>
    );
}
